module.exports = __webpack_public_path__ + "img/742-76d2ee.png";